import { render, staticRenderFns } from "./ProfileUserData.vue?vue&type=template&id=566b4022&"
import script from "./ProfileUserData.vue?vue&type=script&lang=js&"
export * from "./ProfileUserData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports